import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';
import { LandingPage, CreateCRPage, ReviewCRPage, SettingsPage, ImportPage, ClientsPage, ClientDetailPage, AnalyticsPage } from './pages';
import { LoginPage } from './pages/Login/LoginPage';
import { UsersPage } from './pages/Users/UsersPage';
import { AppLayout } from './components/layout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AdminRoute } from './components/auth/AdminRoute';
import { SuperAdminRoute } from './components/auth/SuperAdminRoute';
import { ROUTES, TOAST_CONFIG, GOOGLE_CLIENT_ID } from './constants';
import { store } from './store';

function App() {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={
              <ProtectedRoute>
                <AppLayout>
                  <Routes>
                    <Route path={ROUTES.HOME} element={<LandingPage />} />
                    <Route path={ROUTES.CREATE_CR} element={<CreateCRPage />} />
                    <Route path={ROUTES.EDIT_CR_WORKFLOW} element={<CreateCRPage />} />
                    <Route path={ROUTES.REVIEW_CR} element={<ReviewCRPage />} />
                    <Route path={ROUTES.EDIT_CR} element={<ReviewCRPage />} />
                    <Route path={ROUTES.SETTINGS} element={<SettingsPage />} />
                    <Route path={ROUTES.IMPORT} element={<ImportPage />} />
                    <Route path={ROUTES.CLIENTS} element={<AdminRoute><ClientsPage /></AdminRoute>} />
                    <Route path={ROUTES.CLIENT_DETAIL} element={<AdminRoute><ClientDetailPage /></AdminRoute>} />
                    <Route path={ROUTES.USERS} element={<SuperAdminRoute><UsersPage /></SuperAdminRoute>} />
                    <Route path={ROUTES.ANALYTICS} element={<AdminRoute><AnalyticsPage /></AdminRoute>} />
                  </Routes>
                </AppLayout>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster
            position={TOAST_CONFIG.position}
            toastOptions={TOAST_CONFIG.toastOptions}
          />
        </Router>
      </GoogleOAuthProvider>
    </Provider>
  );
}

export default App;
